import { Injectable } from "@angular/core";
import { NiceAsyncTypeaheadProvider, NiceAsyncTypeaheadSearchResult } from "@recursyve/nice-ui-kit.v2";
import { Observable, lastValueFrom, map } from "rxjs";
import { FindOptionsDto } from "../../../../../api/common/dto/find-options.dto";
import { Sectors } from "../../../properties/models/sectors.model";
import { SectorsApi } from "../sectors.api";

@Injectable()
export class SectorsTypeaheadApi extends NiceAsyncTypeaheadProvider<Sectors> {
    public resource = "sectors";

    private pageSize = 20;

    constructor(private sectorsApi: SectorsApi) {
        super();
    }

    public override async getById(id: number): Promise<Sectors> {
        return lastValueFrom(this.sectorsApi.getById(id));
    }

    public override search(searchQuery: string, page: number): Observable<NiceAsyncTypeaheadSearchResult<Sectors>> {
        const dto: FindOptionsDto = {
            searchQuery,
            page,
            pageSize: this.pageSize
        };

        return this.sectorsApi.search(dto).pipe(
            map(result => ({
                items: result,
                nextPage: result.length === this.pageSize ? page + 1 : null
            }))
        );
    }

    public override format(item: Sectors): string {
        return item.name ?? "-";
    }
}
